import * as Sentry from '@sentry/react';

function escapeRx(s: string) {
    return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

function buildAllowUrlsFromEnv(): RegExp[] | null {
    const envUrl = (process.env.APP_URL || '').trim();
    const envFqdn = (process.env.APP_FQDN || '').trim();

    let host = '';
    if (envUrl) {
        try {
            host = new URL(envUrl).hostname;
            // eslint-disable-next-line no-empty
        } catch {}
    } else if (envFqdn) {
        host = envFqdn;
    }

    if (!host) return null;

    const rx = new RegExp(`^https?:\\/\\/(?:[^/]*\\.)?${escapeRx(host)}\\/`, 'i');

    return [/^app:\/\//i, rx];
}

function extractHttpStatus(event: any, hint: any): number | null {
    const orig = hint?.originalException as any;
    return (
        orig?.response?.status ??
        orig?.status ??
        event?.extra?.['http.status'] ??
        event?.contexts?.response?.status_code ??
        null
    );
}

if (process.env.MIX_SENTRY_JS_LOGS_ENABLED?.toLowerCase() === 'true') {
    const allowUrls = buildAllowUrlsFromEnv();
    Sentry.init({
        dsn: process.env.MIX_SENTRY_JS_DSN,
        tracesSampleRate: parseFloat(process.env.MIX_SENTRY_JS_TRACES_SAMPLE_RATE),
        release: process.env.MIX_SENTRY_JS_RELEASE || 'gglotto@dev',
        ...(allowUrls ? { allowUrls } : {}),

        beforeSend(event, hint) {
            const status = extractHttpStatus(event as any, hint);
            if (status === 401 || status === 422) {
                return null;
            }
            return event;
        },
        integrations: [
            Sentry.rewriteFramesIntegration({
                prefix: 'app:///',
                iteratee: (frame) => {
                    if (frame.filename) {
                        frame.filename = frame.filename
                            .replace(/\?id=\w+$/, '')
                            .replace(/^https?:\/\/[^\/]+/, 'app:///');
                    }
                    return frame;
                },
            }),
        ],
    });
}
